module.exports = __webpack_public_path__ + "img/Diagram@2x.dd8d32f5.png";